// react
import React from 'react'

// components
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import Header from '_components/header/index.jsx'
import NewEntityDialog from '_components/new-entity-dialog/index.jsx'
import ListView from '_components/list-view/index.jsx'

class RegionsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
  }

  toggleModal = () => {
    this.setState((prevState) => ({
      modalOpen: !prevState.modalOpen,
    }))
  }

  render() {
    return (
      <div id="regions-page">
        <Header
          title="Regions"
          actions={[
            {
              children: 'Create New Region',
              onClick: this.toggleModal,
            },
          ]}
        />

        <ListView
          columns={[
            {
              name: 'Name',
              key: 'name',
              link: `/regions/:_id`,
              sortable: true,
            },
            {
              name: 'Countries',
              key: 'countries',
            },
            {
              name: 'Subdivisions',
              key: 'subdivisions',
            },
            {
              format: 'date',
              key: 'updated_at',
              name: 'Last Updated',
              sortable: true,
            },
          ]}
          entities="regions"
          fields={['name', 'countries', 'subdivisions', 'updated_at']}
          searchable={true}
          sort_dir={1}
          sort_key={'name'}
        />
        <Dialog open={this.state.modalOpen} close={this.toggleModal}>
          <NewEntityDialog
            close={this.toggleModal}
            entities="regions"
            title="Enter a name for your new Region"
          />
        </Dialog>
      </div>
    )
  }
}

// export
export default RegionsPage
